import {
    AppointmentsModel
} from "one-card-appointments-table";

import {
    AppointmentData
} from 'one-model-local';

import { formatIso, getday } from 'one-util-date';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the 
 * Appointments Component
 * @param response has the backend 
 * appointment response
 * @param context has settings etc..
 */
//ADPAC-426
function sortFunction(a: AppointmentData, b: AppointmentData) {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    return dateA > dateB ? 1 : -1;
}

export const TransformResponse = (response: any, context: any, patientId: string) => {
    /**
     * @param result contains the transformed response
     */
    let result: AppointmentsModel = {};
    let dataarray: any = [];
    const { settings } = context ? context:"";
    const {uisettings:{dateformat}} = settings ? settings:{uisettings:""};
    if (response && response.length > 0) {
        response.map((ele: any, index:number) => {
            let presentdate: number = new Date().getTime();
            let ddate: string = ele.Date ? ele.Date : "";
            let dtime: string = ele.AppointmentStartTime ? ele.AppointmentStartTime : "";
            let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();

            let data: AppointmentData = {
                key: "",
                date: "",
                department: "",
                departmentId: "",
                appointmentTime: "",
                provider: "",
                providerId: "",
                status: "",
                visitType: "",
                visitTypeID: "",
                appointmentType: "",
                appointmentDuration: "",
                patientId: "",
                patientName: "",
                patientIDType: "",
                contactID: "",
                contactIDType: "",
                day: "",
                AppointmentNotes:"",
                ArrivalTime:""
            };
            data.key = index.toString();
            if (presentdate <= apptdate && (ele.AppointmentStatus === "Scheduled") ) {
                data.appointmentType = "future";
            }
            if (presentdate > apptdate && (ele.AppointmentStatus === "Completed" || ele.AppointmentStatus === "Scheduled")) {
                data.appointmentType = "past";
            }
            if(ele.AppointmentStatus === "Canceled") {
                data.appointmentType = "canceled";
            }
            if(ele.AppointmentStatus === "No Show") {
                data.appointmentType = "noshows"
            }
            if (ele.Providers && ele.Providers.length > 0) {
                data.department = ele.Providers[0]?.DepartmentName ? ele.Providers[0].DepartmentName:"";
                data.departmentId = ele.Providers[0]?.DepartmentIDs?.[0]?.ID ? ele.Providers[0].DepartmentIDs[0].ID:"";
                data.provider = ele.Providers[0]?.ProviderName ? ele.Providers[0].ProviderName : "";
                data.providerId = ele.Providers[0]?.ProviderIDs?.[0]?.ID ? ele.Providers[0].ProviderIDs[0].ID:"";
            }
            data.date = ele.Date ? formatIso(ele.Date,dateformat) : "";
            data.day = ele.Date ? getday(ele.Date) : "";
            data.status = ele.AppointmentStatus ? ele.AppointmentStatus : "";
            data.visitType = ele.VisitTypeName ? ele.VisitTypeName : "";
            data.appointmentTime = ele.AppointmentStartTime ? ele.AppointmentStartTime : "";
            data.patientId = patientId ? patientId:"";
            data.patientIDType = context?.settings?.epicendpoints?.searchID ? context.settings.epicendpoints.searchID:"";
            data.patientName = ele.PatientName ? ele.PatientName:"";
            data.appointmentDuration = ele.AppointmentDuration ? ele.AppointmentDuration:"";
            data.ArrivalTime = ele.ArrivalTime ? ele.ArrivalTime:"";
            if(ele.ContactIDs && ele.ContactIDs.length > 0){
                data.contactID = ele.ContactIDs[0]?.ID ? ele.ContactIDs[0].ID:"";
                data.contactIDType = ele.ContactIDs[0]?.Type ? ele.ContactIDs[0].Type:"";
            }
            if(ele.VisitTypeIDs && ele.VisitTypeIDs.length > 0){
                data.visitTypeID = ele.VisitTypeIDs[0]?.ID ? ele.VisitTypeIDs[0].ID:"";
            }
            data.AppointmentNotes=ele.AppointmentNotes.length>0?ele.AppointmentNotes[0]:''
            dataarray.push(data);
            //ADPAC-426
            dataarray.sort(sortFunction);
        });
        result['data'] = dataarray;
    }
    return result;


}